export default __webpack_public_path__ + "images/b94fe726ad29888be339083a492cb454-wine_small.webp";